"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.CACabinetClient = void 0;

var tslib_1 = require("tslib");

var axios_1 = tslib_1.__importDefault(require("axios"));

var url_parse_1 = tslib_1.__importDefault(require("url-parse"));

var Errors_1 = require("@skbkontur/plugin-js/lib/common/Errors");

var Log_1 = require("@skbkontur/plugin-js/lib/common/Log");

var config_1 = require("./config");

var constants_1 = require("../../utils/constants");

var CertificateUtils_1 = require("../CertificateUtils");

var CACabinetCertificate_1 = require("./CACabinetCertificate");

var CACabinetClient =
/** @class */
function () {
  function CACabinetClient() {
    this.log = Log_1.LogManager.getLog(constants_1.LOG_PREFIX + "\u0421aCabinetClient"); // Use URL object origin property, because ie11 doesn't populate location.origin property
    // in some cases https://stackoverflow.com/a/38930269.

    var host = new url_parse_1.default(window.location.href).origin;
    var externalUrl = host + "/api/";
    var headers = {
      'Content-Type': 'application/json'
    };
    this.axios = axios_1.default.create({
      baseURL: "" + externalUrl,
      headers: headers,
      withCredentials: true
    });
    this.axios.interceptors.response.use(function (response) {
      return response;
    }, function (error) {
      if (error.response) {
        var response = error.response;
        var _a = response.data,
            errorStatus = _a.errorStatus,
            errorMessages = _a.errorMessages;
        var msg = response.status + " " + response.statusText + "." + ("ErrorStatus: " + errorStatus + ". Messages: " + (errorMessages || []).join());
        return Promise.reject(new Errors_1.CommonError(msg, null, errorStatus || 'NoErrorStatus'));
      } else {
        return Promise.reject(new Errors_1.CommonError(error.message, null, CertificateUtils_1.HttpStatus.NetworkError, null, error));
      }
    });
  }

  CACabinetClient.prototype.getUserCertificates = function () {
    var _this = this;

    var url = config_1.PATH.certificates;
    return this.axios.get(url).then(function (response) {
      return _this.processRequisiteCertificates(response.data.Data);
    }).catch(function (error) {
      console.log(error);

      _this.log.error("Method getUserCertificates. Message: " + error.message);

      throw error;
    });
  };

  CACabinetClient.prototype.processRequisiteCertificates = function (rawCertificates) {
    return rawCertificates.map(function (raw) {
      return new CACabinetCertificate_1.CACabinetCertificate(raw);
    });
  };

  return CACabinetClient;
}();

exports.CACabinetClient = CACabinetClient;